import "../styles/AquaFlowPromo.scss";
import aquaflow from "../assets/marketing/aquecedor.png";
import aquaflow_graph from "../assets/marketing/aquecedor2.png";

const Aquecedor = () => {
  return (
    <section className="aqua-flow-promo">
      <img src={aquaflow} alt="Aqua Flow Banner" className="top-image" />

      <div className="features">
        <div>
          <h3>BANHO DE CONFORTO</h3>
          <p>
            Com sua tecnologia avançada, o aquecedor Decor oferece banhos ainda
            mais confortáveis e agradáveis, combinando alta pressão de água com
            a constância e precisão da temperatura escolhida.
          </p>
        </div>
        <div>
          <h3>SISTEMA DE RECIRCULAÇÃO INTEGRADO</h3>
          <p>
            Com sistema de recirculação de água integrado. permite que a água
            acumulada na tubulação retorne ao aquecedor permitindo que ela seja
            reaquecida, evitando desperdícios e economizando tempo.
          </p>
        </div>
        <div>
          <h3>VIDRO TEMPERADO</h3>
          <p>
            Com visual moderno e sofisticado, o vidro temperado é até 5 vezes
            mais resistente do que o vidro comum, suportanto maiores impactos e
            pressões mecânicas.
          </p>
        </div>
      </div>

      <div className="button-wrapper">
        <a
          href={`https://wa.me/555391425203?text=Olá%2C+tenho+interesse+em+seus+serviços+de+${"aquecedores"}.`}
          target="_blank"
          style={{ color: "inherit" }}
        >
          <button>Solicite seu orçamento</button>
        </a>
      </div>
      <img
        src={aquaflow_graph}
        alt="Gráfico de desempenho"
        className="bottom-image"
      />
    </section>
  );
};

export default Aquecedor;
